import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnInit {
  @Input() public show: boolean = true;
  @Input() public dropdown: boolean = true;

  @Output() public onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  public onToggle(): void {
    this.show = !this.show;
    this.onChange.emit(this.show);
  }

}
